import { Analytics, UserProps, Event } from "./types.ts";

export class LoggerAnalytics implements Analytics {
  async track(event: Event, user?: UserProps): Promise<void> {
    try {
      globalThis.console.log(event, user);
    } catch (error) {
      globalThis?.console?.error(error);
    }
  }

  async updateUser(userProps: UserProps): Promise<void> {
    try {
      globalThis.console.log(userProps);
    } catch (error) {
      globalThis?.console?.error(error);
    }
  }

  async getVariant(experimentKey: string): Promise<string | null> {
    try {
      globalThis.console.log(experimentKey);
    } catch (error) {
      globalThis?.console?.error(error);
    }
    return null;
  }
}
